import React from 'react';
import { XIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 bg-gray-50 rounded-lg mb-12" data-id="element-440">
      <div className="max-w-3xl mx-auto" data-id="element-441">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-8" data-id="element-442">
          El Problema Oculto
        </h2>
        <p className="text-lg text-gray-700 mb-8 text-center" data-id="element-443">
          La mayoría de las personas falla al intentar hacer una milhojas porque
          las recetas comunes ocultan los secretos que marcan la diferencia:
        </p>
        <div className="space-y-4 mb-8" data-id="element-444">
          <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-445">
            <div className="bg-red-100 p-2 rounded-full" data-id="element-446">
              <XIcon className="text-red-500" size={18} data-id="element-447" />
            </div>
            <p className="text-gray-700" data-id="element-448">
              <strong data-id="element-449">Las capas se inflan</strong> y quedan desparejas en el
              horno.
            </p>
          </div>
          <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-450">
            <div className="bg-red-100 p-2 rounded-full" data-id="element-451">
              <XIcon className="text-red-500" size={18} data-id="element-452" />
            </div>
            <p className="text-gray-700" data-id="element-453">
              <strong data-id="element-454">El dulce de leche es demasiado líquido o duro</strong> y
              la torta se desarma.
            </p>
          </div>
          <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-455">
            <div className="bg-red-100 p-2 rounded-full" data-id="element-456">
              <XIcon className="text-red-500" size={18} data-id="element-457" />
            </div>
            <p className="text-gray-700" data-id="element-458">
              <strong data-id="element-459">El merengue se baja</strong>, queda opaco o se derrite.
            </p>
          </div>
        </div>
        <p className="text-lg font-medium text-amber-800 text-center" data-id="element-460">
          El verdadero culpable no es tu falta de talento… es que las recetas
          tradicionales no te enseñan las técnicas profesionales que hacen
          posible una milhojas perfecta.
        </p>
      </div>
    </section>;
}